import { Controller } from "@hotwired/stimulus"
export default class extends Controller {
    static targets = ['next', 'prev'];
    connect() {
        this.carousel = null;
        this.ctner = this.element.querySelector('.swiper');

        this.onMouseMove  = this.handleMouseMove.bind(this);
        this.onMouseLeave = this.handleMouseLeave.bind(this);

        this.ctner.addEventListener('mousemove',  this.onMouseMove,  { passive: true });
        this.ctner.addEventListener('mouseleave', this.onMouseLeave, { passive: true });

        let config = {
            slidesPerView: "auto",
            initialSlide: 1,
            spaceBetween: 16,
            centeredSlides: true,
            centeredSlidesBounds: true,
            centerInsufficientSlides: true,
            freeMode: {
                enabled: true,
                sticky: true,
                momentum: false,
            },
            watchOverflow: true,
            observer: true,
            loopAdditionalSlides: 1,
            pagination: {
                el: this.element.querySelector(".js-swiper-pagination"),
                type: "bullets",
                clickable: true,
            },
            navigation: {
                nextEl: this.element.querySelector("[data-swiper-nav='next']"),
                prevEl: this.element.querySelector("[data-swiper-nav='prev']"),
            },
            breakpoints: {
                1000: {
                    freeMode: {
                        enabled: false,
                    }
                }
            }
        };
        this.initCarousel(config);
    }
    disconnect() {
        this.ctner.removeEventListener('mousemove',  this.onMouseMove);
        this.ctner.removeEventListener('mouseleave', this.onMouseLeave);
    }
    initCarousel(config) {
        import(/* webpackChunkName: "swiper" */ 'swiper').then(({Swiper}) => {
            import(/* webpackChunkName: "swiper-modules" */ 'swiper/modules').then(({FreeMode, Navigation, Pagination}) => {
                Swiper.use([FreeMode, Navigation, Pagination]);
                this.carousel = new Swiper(this.ctner, config);
            });
        });
    }
    handleMouseMove(e) {
        if(!window.matchMedia("(max-width: 999px)").matches) {
        const { left, top, width } = this.ctner.getBoundingClientRect();
        const isRight = (e.clientX - left) > width / 2;

        const activeBtn   = isRight ? this.nextTarget : this.prevTarget;
        const inactiveBtn = isRight ? this.prevTarget : this.nextTarget;

        activeBtn.style.transform     = `translate(${e.clientX - left}px, ${e.clientY - top}px)`;
        activeBtn.style.opacity       = '1';
        activeBtn.style.pointerEvents = 'auto';

        inactiveBtn.style.opacity       = '0';
        inactiveBtn.style.pointerEvents = 'none';
        } else {
            this.handleMouseLeave();
        }
    }

    handleMouseLeave() {
        this.nextTarget.style.opacity       = '0';
        this.prevTarget.style.opacity       = '0';
        this.nextTarget.style.pointerEvents = 'none';
        this.prevTarget.style.pointerEvents = 'none';
    }
}